import { Card, Statistic } from 'antd';

const StatsCard = ({ title, value, suffix, prefix, color, loading }) => {
  return (
    <Card className="stat-card" loading={loading}>
      <Statistic
        title={title}
        value={value}
        suffix={suffix}
        prefix={prefix}
        valueStyle={color ? { color } : undefined}
      />
    </Card>
  );
};

export default StatsCard;
